export const packagesData = [
    {
        id: 1,
        image: "assets/img/packages/sekhawati.png",
        Source: "Delhi",
        Destination: "Shekhawati",
        duration: "2 Days",
        people: "7 Person",
        price: "₹10,999",
        description: "Explore the cultural heritage of Shekhawati with our guided tour.",
        car: "Innova",
        title: "Delhi To Shekhawati Tour",
    },
    {
        id: 2,
        image: "assets/img/packages/agra.jpg",
        Source: "Delhi",
        Destination: "Agra",
        duration: "2 Days",
        people: "4 Person",
        price: "₹5,999",
        description: "Visit the iconic Taj Mahal and other attractions in Agra.",
        car: "Sedan",
        title: "Delhi To Agra Tour",
    },
    {
        id: 3,
        image: "assets/img/packages/rishikesh.jpg",
        Source: "Delhi",
        Destination: "Rishikesh",
        duration: "2 Days",
        people: "6 Person",
        price: "₹7,999",
        description: "Experience the serenity of Rishikesh with our exclusive package.",
        car: "Ertiga",
        title: "Delhi To Rishikesh Tour",
    },
    {
        id: 4,
        image: "assets/img/packages/udaipur.jpg",
        Source: "Jaipur",
        Destination: "Udaipur",
        duration: "2 Days",
        people: "6 Person",
        price: "₹13,999",
        description: "Discover the beauty of Udaipur, the City of Joy and Lakes.",
        car: "Innova Crysta",
        title: "Jaipur To Udaipur Tour",
    },
    {
        id: 5,
        image: "assets/img/packages/jodhpur.jpg",
        Source: "Jaipur",
        Destination: "Jodhpur",
        duration: "2 Days",
        people: "6 Person",
        price: "₹12,499",
        description: "Explore the Blue City of Jodhpur with our curated package.",
        car: "Innova",
        title: "Jaipur To Jodhpur Tour",
    },
    {
        id: 6,
        image: "assets/img/packages/sekhawati-2.png",
        Source: "Jaipur",
        Destination: "Sekhawati",
        duration: "3 Days",
        people: "6 Person",
        price: "₹14,999",
        description: "Experience the rich culture of Sekhawati with our best tour guides and services.",
        car: "Innova Crysta",
        title: "Jaipur To Sekhawati Tour",
    },
    {
        id: 7,
        image: "assets/img/packages/chardham.png",
        Source: "",
        Destination: "Chardham Yatra",
        duration: "11 Days",
        people: "",
        price: "",
        description: "Embark on a spiritual journey to Yamunotri, Gangotri, Kedarnath, and Badrinath with expert guides, premium accommodations, and breathtaking Himalayan views.",
        car: "All types of vehicle Available",
        title: "Chardham Yatra Tour",
    },
];